/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { Route } from 'react-router';
import Register from '../Register';
import RegistSuccess from '../User/RegistSuccess';


const RegisterRoutes = (
  <Route>
    <Route path="register" component={Register} />
    <Route path="register_success" component={RegistSuccess} />
  </Route>
);

export default RegisterRoutes;




// WEBPACK FOOTER //
// ./src/containers/Routes/RegisterRoutes.jsx